import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";
import WebServiceContext from "../../webService/WebServiceContext";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Loading } from "../SVG";
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const data = {
    datasets: [
        {
            //label: '# of Votes',
            data: [50, 50],
            backgroundColor: [
                'rgba(180, 220, 100, 0.6)',
                'rgba(110, 140, 40, 0.6)'
            ],
            borderColor: [
                'rgba(180, 220, 100, 1)',
                'rgba(110, 140, 40, 1)'
            ],
            borderWidth: 1,
        },
    ],

};

const options = {
    width: 200,
    height: 100,
    tooltips: { enabled: false },
    rotation: -90,
    circumference: 180,
    //maintainAspectRatio: false
}


type PieChatProps = {
    resType: "年度責任額" | "主管責任額(歸屬後)",
    currentYear?: number
}
const money = (value: number) => {
    var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
    });
    return formatter.format(value)
}

export default (props: PieChatProps) => {
    const ws = useContext(WebServiceContext)
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const [value, setValue] = useState<number>(0)
    const [response, setResponse] = useState<number>(0)


    useEffect(() => {
        setIsLoading(true)
        ws.webservice.asyncPerformance("440042_發薪業績", props.currentYear).then((res: any) => {
            //console.log(res)  


            if (props.resType == "年度責任額") {   
                setResponse(30000)
            } else if (props.resType == "主管責任額(歸屬後)") {
                setResponse(120000)
            }

            if (props.resType == "年度責任額" && res[0][props.resType]) {                
                //console.log(res[0]["年度責任額"])  
                setValue(parseInt(res[0]["年度責任額"]))
                //setResponse(30000)
            } else if (props.resType == "主管責任額(歸屬後)" && res[0][props.resType]) {
                setValue(parseInt(res[0]["主管責任額(歸屬後)"]))
                //setResponse(120000)
            }            
            setIsLoading(false)
        })

        return
    }, [props.currentYear])

    if (isLoading) {
        return (<Loading />)
    } else {
        return (
            <>
                <div className="card-short">
                    <span className="value">
                        {money(value)}
                    </span>
                </div>
                <div className="card-content">
                    <div className="PieChatBox">
                        {
                            (Math.floor((value / response) * 100)) >= 100 ?
                                <img className="hib_seal2" src="./images/hib_seal2.png" />
                                :
                                <div>
                                    <Pie
                                        width={200}
                                        height={100}
                                        className="PieChat"
                                        data={{
                                            datasets: [{
                                                ...data.datasets[0],
                                                data: [
                                                    Math.floor((value / response) * 100),
                                                    100 - (Math.floor((value / response) * 100))
                                                ]
                                            }]
                                        }}
                                        options={options}
                                    />
                                    <p className="percentage">
                                        {Math.floor((value / response) * 100)}%
                                    </p>
                                    <p className="myResMesg">
                                        <span className="current">{money(value)}</span>
                                        /
                                        <span className="total">{money(response)}</span>
                                    </p>
                                </div>
                        }
                    </div>
                </div>
            </>
        )
    }
};
